import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TABLE-OBJECT
\*------------------------------------ */
/**
 * Table object host (cat-table-object)
 */
:host {
  display: contents;
}

/**
 * Table object
 */
.cat-c-table-object {
  width: var(--cat-table-min-width, 100%);
}
.cat-c-table-object.cat-c-table-cell-size-sm {
  --cat-c-table-cell--min-height: calc(var(--size-base-unit) * 4);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1);
}
.cat-c-table-object.cat-c-table-cell-size-md {
  --cat-c-table-cell--min-height: calc(var(--size-base-unit) * 5);
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 1.5);
}
.cat-c-table-object.cat-is-even-order-stripe {
  --cat-c-table-body-even-background-pass-down: var(--cat-theme-color-background-subtle);
}
.cat-c-table-object.cat-is-odd-order-stripe {
  --cat-c-table-body-odd-background-pass-down: var(--cat-theme-color-background-subtle);
}

/**
 * Table object body
 * 1) Position relative to position overflow gradients
 */
.cat-c-table-object__body {
  position: relative; /* 1 */
  /**
   * Table object body within table object overflow left
   */
  /**
   * Table object body within table object overflow right
   */
}
.cat-is-overflow-left .cat-c-table-object__body {
  /**
   * Left overflow gradient for the table object body
   */
}
.cat-is-overflow-left .cat-c-table-object__body:before {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), var(--cat-theme-color-background-default), rgba(255, 255, 255, 0.001) 30%);
  height: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
  pointer-events: none;
}
.cat-is-overflow-right .cat-c-table-object__body {
  /**
   * Right overflow gradient for the table object body
   */
}
.cat-is-overflow-right .cat-c-table-object__body:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, 90deg), rgba(255, 255, 255, 0.001) 30%, var(--cat-theme-color-background-default));
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: calc(var(--size-base-unit) * 6);
  z-index: var(--cat-z-index-100);
  pointer-events: none;
}

/**
 * Table object body inner
 * 1) Actual container within the table object body that scrolls
 * 2) Fixed height required for position sticky to work on child elements
 */
.cat-c-table-object__body-inner {
  overflow: auto; /* 1 */
  width: 100%;
  height: 100%;
  max-height: var(--cat-table-height, 400px); /* 2 */
}
.cat-c-table-object__body-inner::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
.cat-c-table-object__body-inner::-webkit-scrollbar-track {
  border-radius: 12px;
  background: var(--cat-theme-color-background-subtle);
  margin-inline-start: var(--cat-table-scrollbar-margin-left);
  margin-block-start: var(--cat-table-scrollbar-margin-top);
}
.cat-c-table-object__body-inner::-webkit-scrollbar-thumb {
  background: var(--cat-theme-color-background-subtle-hover);
  border-radius: 12px;
}

/**
 * Table object header
 * 1) The containers the appear above the table object body
 * 2) Aligns the content into a row
 */
.cat-c-table-object__header {
  width: 100%;
  /**
   * Align slotted items in a row.
   */
}
.cat-c-table-object__header slot {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/**
 * Table object header
 * 1) The container that appears above the table object body
 */
.cat-c-table-object__header {
  margin-block-end: var(--cat-space-x-small);
}

/**
 * Table object footer
 * 1) The container that appears below the table object body
 */
.cat-c-table-object__footer {
  margin-block-start: var(--cat-space-x-small);
}

/**
 * Table object tooltip
 * 1) The tooltip that appears over table header cells if they are greater than two lines
 * 2) Tooltip is positioned absolutely to the object body
 */
.cat-c-table-object__tooltip {
  height: 0;
  width: 0;
  position: absolute;
  z-index: var(--cat-z-index-top);
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}

/**
 * Table bulk actions
 * 1) The flyout container for the bulk actions that appears above the first table cell header
 */
.cat-c-table-object__bulk-action {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: fit-content;
  position: absolute;
  inset-block-start: calc(calc(var(--size-base-unit) * 4.75) * -1);
  inset-inline-start: 0;
  color: var(--cat-theme-color-content-strong);
  background-color: var(--cat-theme-color-background-brand);
  padding: var(--cat-space-3x-small) var(--cat-space-small);
  z-index: var(--cat-z-index-500);
  opacity: 0;
  visibility: hidden;
  /**
   * The indication arrow at the bottom of the flyout
   */
}
.cat-c-table-object__bulk-action:before {
  content: "";
  display: block;
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  transform: rotate(45deg);
  background-color: var(--cat-theme-color-background-brand);
  position: absolute;
  inset-inline-start: var(--cat-space-x-large);
  inset-block-end: calc(var(--cat-space-3x-small) * -1);
}
.cat-is-bulk-action-active .cat-c-table-object__bulk-action {
  opacity: 1;
  visibility: visible;
}

/**
 * Table bulk actions title
 * 1) The title to the bulk action container that displays before the actions
 */
.cat-c-table-object__bulk-action-title {
  font-weight: normal;
  margin-inline-end: var(--cat-space-x-small);
  white-space: nowrap;
}

/**
 * Table bulk actions buttons
 * 1) The slotted container that holds all the action buttons
 */
.cat-c-table-object__bulk-action-buttons {
  display: flex;
  align-items: center;
  gap: var(--cat-space-small);
}

/**
 * Table bulk actions buttons slotted
 * 1) Styling for all the slotted item in the bulk actions buttons wrapper
 * 2) Styling for the contextual menu trigger for more bulk action items
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*),
.cat-c-table-object__bulk-action-more-trigger {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  background: transparent;
  outline: 0;
  border: 0;
  margin: 0;
  text-decoration: none;
  transition: all 0.15s ease;
  color: var(--cat-theme-color-content-strong);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/**
 * Table bulk actions buttons slotted hover, focus, active
 * 1) Hover, focus, and active states for slotted items and contextual menu trigger
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:hover),
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:focus),
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:active),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:hover),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:focus),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:active),
.cat-c-table-object__bulk-action-more-trigger:hover,
.cat-c-table-object__bulk-action-more-trigger:focus,
.cat-c-table-object__bulk-action-more-trigger:active {
  color: var(--cat-theme-color-content-strong-hover);
}

/**
 * Table bulk actions buttons slotted focus-visible
 * 1) Focus visible state for slotted items.
 */
.cat-c-table-object__bulk-action-buttons slot[name=bulkAction]::slotted(*:focus-visible),
.cat-c-table-object__bulk-action-buttons slot[name=bulkActionSingle]::slotted(*:focus-visible),
.cat-c-table-object__bulk-action-more-trigger:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Table bulk actions more trigger icon
 * 1) The arrow down icon that appears next to the more trigger in the bulk actions
 */
.cat-c-table-object__bulk-action-more-trigger-icon {
  --cat-icon-width: calc(var(--size-base-unit) * 1);
  --cat-icon-height: calc(var(--size-base-unit) * 1);
  margin-inline-start: var(--cat-space-3x-small);
}

/**
 * Table modal for mobile list view
 */
.cat-c-modal__body {
  display: flex;
  flex-direction: column;
  gap: var(--cat-space-medium);
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
}

.cat-c-table-object:not(.cat-c-table-object--has-header-slot) .cat-c-table-object__header, .cat-c-table-object:not(.cat-c-table-object--has-footer-slot) .cat-c-table-object__footer, .cat-c-table-object:not(.cat-c-table-object--has-bulk-action-single-slot) [part=part-bulkActionSingle], .cat-c-table-object:not(.cat-c-table-object--has-bulk-action-slot) [part=part-bulkAction], .cat-c-table-object:not(.cat-c-table-object--has-bulk-action-single-more-slot) [part=part-bulkActionSingleMore], .cat-c-table-object:not(.cat-c-table-object--has-bulk-action-more-slot) [part=part-bulkActionMore], .cat-c-table-object:not(.cat-c-table-object--has-bulkaction-more-slot) [part=bulk-action-more], .cat-c-table-object:not(.cat-c-table-object--has-any-bulk-action) :is([part=part-bulkActionSingle], [part=part-bulkAction]), .cat-c-table-object:not(.cat-is-bulk-action-active) .cat-c-table-object__bulk-action {
  display: none;
}
`;
       